<template>
    <div class="v-connected-container">
        <template v-for="(dt,index) in value">
            <div class="v-connected" :key="index" :class="{'mb-1':index != value.length - 1}">
                <template v-for="(val,_i) in dt">
                    <div class="v-connected-item shadow-sm" :key="index + _i">
                        <slot name="data" :data="val"></slot>
                    </div>
                    <div v-if="_i != dt.length - 1" :key="'connector' + index + _i" class="v-connected-connector"></div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>

export default {
    name:"v-connected",
    props:{
        value:{
            type:Array,
            default:function(){
                return [];
            },
        },
    },
}
</script>

<style>
.v-connected .v-connected-item{
    border-radius: 5px;
    padding: 0.5rem;
    border: 1px solid #ebe9f1;
    transition: border 0.3s ease-in-out;
}
.v-connected .v-connected-connector{
    width: 0.25rem;
    height: 1rem;
    background-color: #ebe9f1;
    margin-left: 1rem;
    transition: background-color 0.3s ease-in-out;
}

.v-connected:hover .v-connected-connector{
    background-color: hsl(255, 22%, 75%) !important;
}

.v-connected:hover .v-connected-item{
    border-color: hsl(255, 22%, 75%) !important;
}

.dark-layout .v-connected:hover .v-connected-connector{
    background-color: hsl(255, 22%, 95%) !important;
}

.dark-layout .v-connected:hover .v-connected-item{
    border-color: hsl(255, 22%, 95%) !important;
}


.dark-layout .v-connected .v-connected-connector{
    background-color: hsl(255, 22%, 50%);
}
.dark-layout .v-connected .v-connected-item{
    border-color: hsl(255, 22%, 50%);
}
</style>